<script>
import Tooltip from 'element-ui/lib/tooltip';

export default Tooltip;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/tooltip.css';

.el-tooltip__popper .popper__arrow {
  direction: ltr;
}
</style>
